import {
  FieldMappingFileField,
  FieldMappingFileFieldProps,
} from '@components/field-mapping-file-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormFieldMappingFileFieldProps<T = unknown> = FormFieldProps<
  FieldMappingFileFieldProps,
  T
>;

export function FormFieldMappingFileField<T>(props: FormFieldMappingFileFieldProps<T>) {
  const formFieldProps = useFormField(props);

  return <FieldMappingFileField {...props} {...formFieldProps} />;
}
